//
// This is the client side entry point for the React app.
//

import React from "react";
// import { render, hydrate } from "react-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import { routes } from "./routes.au.desktop";
import { BrowserRouter } from "react-router-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import rootReducer from "./reducers/index.au.desktop";
import { renderRoutes } from "react-router-config";
import {thunk as thunkFunction} from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import { loadableReady } from "@loadable/component";
import { initializeSentry, sentryReduxEnhancer } from "../client/utils/sentry/initialize-sentry";
import { ThemeProvider } from "@cars24/turbo-web/lib/theme-provider";
import { COUNTRY } from "./constants/app-constants";

// Import Geist Sans font
import "@fontsource/geist-sans/400.css"; // Regular
import "@fontsource/geist-sans/500.css"; // Medium
import "@fontsource/geist-sans/600.css"; // Semibold
import "@fontsource/geist-sans/700.css"; // Bold

// Import global typography styles
import "./components/shared/typography/styles.css";
const persistConfig = {
    key: "rootDesktopAU",
    storage,
    version: 1,
    whitelist: ["userRegoVin"]
};
initializeSentry();

const persistedReducer = persistReducer(persistConfig, rootReducer);
//
const middlewares = [thunkFunction];
const DEBUG = process.env.NODE_ENV === "development";
const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && DEBUG
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name
            // actionsBlacklist, actionsCreators, serialize...
            trace: true
        }) : compose;
const enhancer = composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer);

//
// Redux configure store with Hot Module Reload
//
const configureStore = (initialState) => {
    const store = createStore(persistedReducer, initialState, enhancer);
    const persistor = persistStore(store);

    if (module.hot) {
        module.hot.accept("./reducers/index.au.desktop", () => {
            const nextRootReducer = require("./reducers/index.au.desktop").default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return { store, persistor };
};

const { store, persistor } = configureStore(window.__PRELOADED_STATE__);

// const start = App => {
//     const jsContent = document.querySelector(".js-content");
//     const reactStart = window.__PRELOADED_STATE__ && jsContent.innerHTML ? hydrate : render;

//     loadableReady(() =>
//         reactStart(
//             <Provider store={store}>
//                 <PersistGate loading={null} persistor={persistor}>
//                     <BrowserRouter>
//                         <App />
//                     </BrowserRouter>
//                 </PersistGate>
//             </Provider>,
//             jsContent
//         ));
// };

// // window.webappStart = () => start(() => renderRoutes(routes));
// start(() => renderRoutes(routes));

const start = App => {
    const jsContent = document.querySelector(".js-content");

    const Application = (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {() => (
                    <BrowserRouter>
                        <ThemeProvider initialTheme={COUNTRY.name}>
                            <App />
                        </ThemeProvider>
                    </BrowserRouter>
                )}
            </PersistGate>
        </Provider>
    );

    if (window.__PRELOADED_STATE__ && jsContent.innerHTML) {
        loadableReady(() => {
            hydrateRoot(jsContent, Application);
        });
    } else {
        loadableReady(() => {
            const root = createRoot(jsContent);
            loadableReady(() => {
                root.render(Application);
            });
        });
    }
};
start(() => renderRoutes(routes));

//
// Hot Module Reload setup
//
if (module.hot) {
    module.hot.accept("./routes.au.desktop", () => {
        const r = require("./routes.au.desktop");
        start(() => renderRoutes(r.routes));
    });
}
